import script from "./MobileMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MobileMenu.vue?vue&type=style&index=0&id=87494da6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87494da6"]])

export default __exports__